// ---------------------------------------------------------
// Make mobile menu slide in
// ---------------------------------------------------------

window.addEventListener("DOMContentLoaded", () => {
  const footerMenuIcon = document.querySelector(".navbaricon-menu");
  const slidingMenu = document.querySelector(".mobile-navbar-div");
  footerMenuIcon.addEventListener("click", () => {
    if (slidingMenu.classList.contains("show-menu-right")) {
      slidingMenu.classList.remove("show-menu-right");
    } else {
      slidingMenu.classList.add("show-menu-right");
    }
  });

  // window.addEventListener("scroll", e => {
  //   const scrolled = window.pageYOffset;
  //   const headerBackground = document.querySelector("header.page-heading");
  //   if (headerBackground) {
  //     headerBackground.style.marginTop = -(scrolled * 0.2) + "px";
  //   }
  // });
  //
  //

  window.addEventListener("scroll", () => {
    const progressBar = document.getElementById("myBar");
    let goodPercentage = 0;
    if (progressBar) {
      const scrolling =
        document.documentElement.scrollTop || document.body.scrollTop;
      const position =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const percentage = (scrolling / position) * 100;

      if (percentage <= 100) {
        goodPercentage = percentage;
      } else {
        goodPercentage = 100;
      }
      progressBar.style.width = goodPercentage + "%";
    }
  });

  // Make the mobile menu submenus open on click
  var menuItems = document.querySelectorAll(
    ".mobile-navbar-div .menu-item-has-children > a"
  );

  menuItems.forEach(function (item) {
    item.addEventListener("click", function (event) {
      console.log("Menu item clicked!");

      // Check if the clicked item has a submenu
      var submenu = event.target.nextElementSibling;
      if (submenu && submenu.classList.contains("sub-menu")) {
        // Prevent the default action (navigation)
        event.preventDefault();

        // Toggle the submenu
        if (submenu.style.display === "block") {
          submenu.style.display = "none";
        } else {
          submenu.style.display = "block";
        }
      }
    });
  });
});
